"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Fragments_1 = require("../../../utils/queries/Fragments");
var graphql_1 = require("graphql");
var GET_QUEUED_RECORDINGS_QUERY = "\nquery getQueuedRecordingSet($deviceId: ID!) {\n  customer {\n    decoder(id: $deviceId) {\n      queuedRecordings {\n        ...queuedRecordingSetFragment\n      }\n    }\n  }\n}\n" + graphql_1.print(Fragments_1.QUEUED_RECORDING_SET_FRAGMENT) + "\n" + graphql_1.print(Fragments_1.SLOT_SUBSCRIPTION_FRAGMENT) + "\n";
exports.default = GET_QUEUED_RECORDINGS_QUERY;
//# sourceMappingURL=getQueuedRecordings.js.map